import { apiService } from './apiService';
import ToastMe from '@/components/ui/ToastMe';
import { GeneralSettingList } from '@/constants/GeneralSettingConstant';
import { getGeneralSettingStoreAfterLoginService } from './AuthServices';

export function getSettingService(data) {
    return apiService({
        method: 'POST',
        url: '/setting/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updateSettingService(data) {
    return apiService({
        method: 'POST',
        url: '/setting',
        data,
        onSuccess: (dispatch, res) => {
            ToastMe(res.data.message, 'success');
            // Reload all general settings to keep UI in sync
            dispatch(getGeneralSettingStoreAfterLoginService({ key_list: GeneralSettingList }))
                .then(() => {})
                .catch(() => {});
        },
        onFailure: () => {},
    });
}

export function getShimbirrPairingBundleService() {
    return apiService({
        method: 'GET',
        url: '/setting/shimbirr-auth/pairing',
        onSuccess: () => {},
        onFailure: () => {},
    });
}
